import ViewTable from "modules/DeclareLeave/components/CustomTable";

import { Box, Button, Divider, IconButton, Typography } from "@mui/material";
import pxToRem from "theme/base/pxToRem";

import { useDispatch, useSelector } from "react-redux";
import {
  listTimeKeepingHRSelector,
  rangeTimeKeepingSelector,
} from "modules/DeclareLeave/redux/selector";

import EmptyState from "components/common/EmptyState";
import { Header, TimeKeepingWrapper } from "./styles";
import FilterTimeKeeping from "./Filter";
import useColumns from "./useColumns";
import { useEffect, useState } from "react";
import {
  CATEGORY_TYPE,
  getCategoryOptionStart,
} from "modules/DeclareLeave/redux/getCategoryOption";
import {
  getListTimeKeepingHRStart,
  resetListTimeKeepingHR,
} from "modules/DeclareLeave/redux/getListTimeKeepingHR";
import {
  resetControlPageFilter,
  setupControlPage,
} from "components/common/ListInfinitiveScrolling/redux/controlInfinitiveScrolling";
import {
  formFilterTimeKeepingHRReset,
  formFilterTimeKeepingHRUpdate,
} from "modules/DeclareLeave/redux/formFilterTimeKeepingHR";
import { exportTimeKeepingHRStart } from "modules/DeclareLeave/redux/exportTimeKeepingHR";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

import { ReactComponent as IconArrowHeadDown } from "assets/svg/20-arrowhead-down.svg";

import moment from "moment";
import {
  getRangeTimeKeepingStart,
  resetGetRangeTimeKeeping,
} from "modules/DeclareLeave/redux/getRangeTimeKeeping";
import { Tab, TabContent, Tabs } from "../OderManagement/style";
import { useNavigate, useParams } from "react-router-dom";
import pathRoutes from "routes/pathRoutes";
import { ListReport } from "./ListReport";
import { useDialog, useLegacyEffect } from "helper/customHook";
import { ReactComponent as IconUpload } from "assets/svg/20-upload-1.svg";
import { ReactComponent as IconDownload } from "assets/svg/20-download.svg";
import ModalImport from "./Modal/ModalImport";
import { DIALOG } from "helper/enum/dialogEnum";

const locale = "vi";
export const TimeKeepingHR = () => {
  const navigate = useNavigate();
  const { type } = useParams();

  const dispatch = useDispatch();
  const timeKeepingData = useSelector(rangeTimeKeepingSelector);
  const { data, totalRecords } = useSelector(listTimeKeepingHRSelector);
  const importDialog = useDialog(DIALOG.IMPORT_TIMEKEEPING);

  const { columns } = useColumns();

  const [monthSelected, setMonthSelected] = useState(moment());
  const [open, setOpen] = useState(false);

  useEffect(() => {
    dispatch(setupControlPage({ id: "timeKeepingHR", limit: 200 }));

    dispatch(getListTimeKeepingHRStart());
    const timeNow = {
      month: moment().month() + 1,
      year: moment().year(),
    };
    dispatch(getRangeTimeKeepingStart(timeNow));

    return () => {
      dispatch(resetControlPageFilter({ id: "timeKeepingHR", limit: 200 }));
      dispatch(resetListTimeKeepingHR());
      dispatch(formFilterTimeKeepingHRReset());
      dispatch(resetGetRangeTimeKeeping());
    };
  }, [dispatch]);

  useLegacyEffect(() => {
    dispatch(
      getCategoryOptionStart({
        categoryType: CATEGORY_TYPE.WORKING_AREA,
      })
    );
    dispatch(
      getCategoryOptionStart({
        categoryType: CATEGORY_TYPE.JOB_TITLE,
      })
    );
    dispatch(
      getCategoryOptionStart({
        categoryType: CATEGORY_TYPE.LEAVE_REASON,
      })
    );
    dispatch(
      getCategoryOptionStart({
        categoryType: CATEGORY_TYPE.DEPT_LEVEL1,
      })
    );
    dispatch(
      getCategoryOptionStart({
        categoryType: CATEGORY_TYPE.DEPT_LEVEL2,
      })
    );
    dispatch(
      getCategoryOptionStart({
        categoryType: CATEGORY_TYPE.TIMEKEEPING_TYPE,
      })
    );
  }, [dispatch]);

  const handleChangeMonth = (newValue) => {
    setMonthSelected(newValue);
    const timeSelected = {
      month: newValue.month() + 1,
      year: newValue.year(),
    };
    dispatch(
      formFilterTimeKeepingHRUpdate({
        ...timeSelected,
      })
    );
    dispatch(getRangeTimeKeepingStart(timeSelected));
    dispatch(resetControlPageFilter({ id: "timeKeepingHR", limit: 200 }));
    dispatch(resetListTimeKeepingHR());
    dispatch(getListTimeKeepingHRStart());
  };

  const handleClickNavigate = (tabContent: string) => {
    navigate(`${pathRoutes.declareLeave.base}/timeSheet-HR/${tabContent}`);
  };

  return (
    <TimeKeepingWrapper>
      <Tabs sx={{ margin: 0 }}>
        <Tab
          active={!type || type === "time-keeping"}
          onClick={() => handleClickNavigate("time-keeping")}
          fontWeight={500}
        >
          Bảng chấm công
        </Tab>
        {/* lên prod ở sprint sau */}
        <Tab
          active={type === "report"}
          onClick={() => handleClickNavigate("report")}
          fontWeight={500}
        >
          Các báo cáo
        </Tab>
      </Tabs>
      <TabContent
        sx={(theme) => ({
          tbody: {
            tr: {
              "&:hover": {
                backgroundColor: `${theme.palette.background.bgBrandPrimary} !important`,
                cursor: "pointer",
              },
            },
            td: {
              fontSize: `12px !important`,
            },
          },
          marginX: 0,
        })}
      >
        {(!type || type === "time-keeping") && (
          <>
            <Header>
              <Box display={"flex"} alignItems={"center"} gap={1}>
                <Box display={"flex"} alignItems={"center"}>
                  <Typography
                    fontSize={18}
                    fontWeight={600}
                    onClick={() => setOpen(!open)}
                  >
                    Bảng tổng hợp chấm công{" "}
                    {moment(timeKeepingData?.fromDate, "YYYY-MM-DD").format(
                      "DD/MM"
                    )}{" "}
                    -{" "}
                    {moment(timeKeepingData?.toDate, "YYYY-MM-DD").format(
                      "DD/MM"
                    )}
                  </Typography>
                  <LocalizationProvider
                    dateAdapter={AdapterMoment}
                    adapterLocale={locale}
                  >
                    <DatePicker
                      views={["month", "year"]}
                      sx={(theme) => ({
                        fieldset: {
                          border: "none",
                        },
                        ".MuiInputBase-root.MuiOutlinedInput-root": {
                          paddingRight: pxToRem(4),
                          input: {
                            width: pxToRem(10),
                            textTransform: "capitalize",
                            color: theme.palette.text.textPrimary,
                            cursor: "pointer",
                            padding: 0,
                            // display: "none",
                            opacity: 0,
                          },
                        },
                        ".MuiInputAdornment-root.MuiInputAdornment-positionEnd":
                          {
                            opacity: 0,
                            position: "absolute",
                            right: pxToRem(50),
                            button: {
                              width: pxToRem(140),
                              marginRight: `-${pxToRem(75)}`,
                            },
                          },
                      })}
                      value={monthSelected}
                      format="MM - YYYY"
                      open={open}
                      onOpen={() => setOpen(true)}
                      onClose={() => setOpen(false)}
                      openTo="month"
                      closeOnSelect={true}
                      slots={{ actionBar: () => null }}
                      onChange={handleChangeMonth}
                    />
                  </LocalizationProvider>
                </Box>
                <IconButton
                  sx={(theme) => ({
                    svg: { path: { fill: theme.palette.icon.icPrimary } },
                    // pointerEvents: "none",
                  })}
                  onClick={() => setOpen(!open)}
                >
                  <IconArrowHeadDown />
                </IconButton>
              </Box>
              <Box display={"flex"} justifyContent={"center"} gap={pxToRem(12)}>
                <Button
                  onClick={() => {
                    importDialog.open();
                  }}
                  variant="outlined"
                  color="success"
                  sx={{
                    width: pxToRem(100),
                    borderRadius: pxToRem(16),
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: pxToRem(6),
                  }}
                >
                  <span style={{ fontSize: pxToRem(13) }}>Import</span>
                  <IconUpload />
                </Button>
                <Button
                  onClick={() => {
                    dispatch(exportTimeKeepingHRStart());
                  }}
                  variant="outlined"
                  color="primary"
                  sx={{
                    width: pxToRem(130),
                    borderRadius: pxToRem(16),
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: pxToRem(6),
                  }}
                >
                  <span style={{ fontSize: pxToRem(13) }}>Xuất Excel</span>
                  <IconDownload />
                </Button>
              </Box>
            </Header>
            <FilterTimeKeeping />
            <ViewTable
              id="timeKeepingHR"
              data={data ?? []}
              columns={columns}
              columnPinning={{
                left: [],
                right: ["totalWorkDays"],
              }}
              handleFetchMore={() => {
                dispatch(getListTimeKeepingHRStart());
              }}
              messageEmpty={
                <EmptyState
                  message="Không có dữ liệu"
                  sx={(theme) => ({
                    h6: {
                      color: theme.palette.text.textSecondary,
                    },
                  })}
                />
              }
              handleOnClickedRow={(item) => {
                // item.id;
              }}
              handleSelection={(e) => {}}
              height={600}
              isHasMore={data?.length < totalRecords}
            />

            <Divider />
          </>
        )}
        {type === "report" && <ListReport />}
      </TabContent>
      <ModalImport />
    </TimeKeepingWrapper>
  );
};
